export const searchGetLoading = s => s.search?.get('loading');
export const searchGetSuccess = s => s.search?.get('success');
export const searchGetResult = s => s.search?.get('result').toJS();
